package com.essntl.features.category.ui.allcategories

import com.essntl.features.category.domain.model.CategoryModel

sealed interface AllCategoriesEvent {
    data object GetAllCategories : AllCategoriesEvent
    data class AddCategory(val c: CategoryModel) : AllCategoriesEvent
    data class EditCategory(val c: CategoryModel) : AllCategoriesEvent
    data class DeleteCategory(val c: CategoryModel) : AllCategoriesEvent
}